import type { ContentBlock } from '@agentclientprotocol/sdk';

/**
 * Extracts a plain-text representation from an ACP prompt's content blocks.
 *
 * The ACP spec requires agents to support `text` and `resource_link` as a
 * baseline. `resource_link` blocks carry a URI that identifies a resource the
 * client wants the agent to consider; we surface it as a Markdown-style
 * reference so the LLM can reason about it.
 *
 * Other block types (image, audio, embedded resource) are declared unsupported
 * in our `promptCapabilities` and are silently skipped here.
 */
export function extractText(prompt: ContentBlock[]): string {
  return prompt
    .flatMap((block) => {
      if (block.type === 'text') return [block.text];
      if (block.type === 'resource_link') {
        const label = block.title ?? block.name ?? block.uri;
        return [`[${label}](${block.uri})`];
      }
      return [];
    })
    .join('\n');
}
